import {Expose} from 'class-transformer';
import {AbstractApiModel} from './abstract.api.model';


export class MetadataApiModel extends AbstractApiModel {
  @Expose() public metaTitle: string;
  @Expose() public metaKeywords: string;
  @Expose() public metaDescription: string;
}
